import { render, staticRenderFns } from "./ui-badge.vue?vue&type=template&id=9fa6b272&"
import script from "./ui-badge.vue?vue&type=script&lang=js&"
export * from "./ui-badge.vue?vue&type=script&lang=js&"
import style0 from "./ui-badge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa6b272')) {
      api.createRecord('9fa6b272', component.options)
    } else {
      api.reload('9fa6b272', component.options)
    }
    module.hot.accept("./ui-badge.vue?vue&type=template&id=9fa6b272&", function () {
      api.rerender('9fa6b272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-badge/ui-badge.vue"
export default component.exports